module.exports = __webpack_public_path__ + "img/ssb_menu16.84da69bf.png";